module.exports = __webpack_public_path__ + "img/1440.99a27179.jpg";